import { ActivityIndicator, StyleSheet, View } from "react-native";
import { COLORS as DEFAULT_COLORS } from "../theme/colors";
import { COLORS as APP_COLORS } from "../../theme/colors";

const COLORS = { ...DEFAULT_COLORS, ...APP_COLORS };

const LoadingIndicator = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <View
          style={styles.loadingIndicatorContainer}
          testID="activity-indicator"
          accessible={true}
          accessibilityLabel="Loading"
        >
          <ActivityIndicator size={80} color={COLORS.loading} />
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  loadingIndicatorContainer: {
    position: "absolute",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
  },
});

export default LoadingIndicator;
